import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProductCostSettings from "@/pages/ProductCostSettings";
import AddEvent from "@/pages/AddEvent";
import EventHistory from "@/pages/EventHistory";
import EventDetails from "@/pages/EventDetails";
import Transactions from "@/pages/Transactions";
import MonthlyPL from "@/pages/MonthlyPL";
import AnnualPL from "@/pages/AnnualPL";
import TaxPreparation from "@/pages/TaxPreparation";
import Purchases from "@/pages/Purchases";
import Assets from "@/pages/Assets";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import MigrationTool from "@/pages/MigrationTool";
import Navigation from "@/components/Navigation";
import { AuthProvider } from "@/auth/AuthProvider";
import ProtectedRoute from "@/auth/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <>
                    <Navigation />
                    <Routes>
                      <Route path="/" element={<AddEvent />} />
                      <Route path="/add-event" element={<AddEvent />} />
                      <Route path="/events" element={<EventHistory />} />
                      <Route path="/events/:id" element={<EventDetails />} />
                      <Route path="/events/:id/edit" element={<AddEvent />} />
                      <Route path="/transactions" element={<Transactions />} />
                      <Route path="/monthly-pl" element={<MonthlyPL />} />
                      <Route path="/annual-pl" element={<AnnualPL />} />
                      <Route path="/tax-prep" element={<TaxPreparation />} />
                      <Route path="/purchases" element={<Purchases />} />
                      <Route path="/assets" element={<Assets />} />
                      <Route path="/products" element={<ProductCostSettings />} />
                      <Route path="/migrate" element={<MigrationTool />} />
                    </Routes>
                  </>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
